export const isIssueKey = (issueKey: string): boolean =>
	issueKey.match(/^[A-Za-z0-9]+-\d+$/) !== null;
